var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 192,
    viewBox: "0 0 296 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e2pz0wc16a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.334 44.298h-84.807a.824.824 0 0 0-.824.824v113.625c0 .454.369.823.824.823h84.807a.824.824 0 0 0 .823-.823V45.122a.824.824 0 0 0-.823-.824z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.334 159.57h-84.807a.823.823 0 0 1-.824-.823V45.122a.825.825 0 0 1 .824-.824h84.807a.826.826 0 0 1 .823.824v113.625a.822.822 0 0 1-.823.823zM129.527 44.71a.412.412 0 0 0-.412.412v113.625a.41.41 0 0 0 .412.411h84.807a.41.41 0 0 0 .411-.411V45.122a.412.412 0 0 0-.411-.412h-84.807z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.188 70.105h-60.517a1.544 1.544 0 1 1 0-3.087h60.517a1.544 1.544 0 1 1 0 3.087zM202.188 80.089h-60.517a1.544 1.544 0 1 1 0-3.088h60.517a1.544 1.544 0 1 1 0 3.088zM202.188 90.072h-60.517a1.544 1.544 0 1 1 0-3.088h60.517a1.544 1.544 0 1 1 0 3.088zM202.188 100.055h-60.517a1.544 1.544 0 1 1 0-3.088h60.517a1.545 1.545 0 0 1 0 3.088zM202.188 110.039h-60.517a1.543 1.543 0 0 1 0-3.088h60.517a1.547 1.547 0 0 1 1.544 1.544 1.544 1.544 0 0 1-1.544 1.544z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.588 89.346c-.037.13-.064.26-.08.394l-10.726 5.414-2.445-1.595-2.89 3.374 4.053 3.245a1.941 1.941 0 0 0 2.325.073l11.188-7.855a2.545 2.545 0 0 0 3.523-1.908 2.541 2.541 0 0 0-1.224-2.62 2.545 2.545 0 0 0-3.724 1.478z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.43 95.358-3.556 4.205a1.087 1.087 0 0 1-1.277.291 1.094 1.094 0 0 1-.374-.275l-3.627-4.121a3.027 3.027 0 0 1 3.924-4.612l4.652 2.882a1.097 1.097 0 0 1 .502.756 1.09 1.09 0 0 1-.244.874z",
    fill: "#00A39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.041 156.989h2.524l1.2-9.734h-3.724v9.734z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.397 156.165h4.97a3.168 3.168 0 0 1 3.167 3.167v.103h-8.137v-3.27z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.472 129.882.718 2.419 9.674-1.616-1.06-3.571-9.332 2.768z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.079 129.031 1.413 4.764a3.169 3.169 0 0 1-2.135 3.938l-.099.029-2.314-7.801 3.135-.93z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.708 132.487h-40.149c-.566 0-1.025-.691-1.025-1.544 0-.852.459-1.544 1.025-1.544h40.149c.566 0 1.024.692 1.024 1.544 0 .853-.458 1.544-1.024 1.544zM202.708 141.338h-40.149c-.566 0-1.025-.691-1.025-1.544 0-.852.459-1.544 1.025-1.544h40.149c.566 0 1.024.692 1.024 1.544 0 .853-.458 1.544-1.024 1.544z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.157 56.167c6.555 0 11.869-5.314 11.869-11.868 0-6.555-5.314-11.87-11.869-11.87s-11.869 5.315-11.869 11.87c0 6.554 5.314 11.868 11.869 11.868z",
    fill: "#00A39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.212 43.515a.783.783 0 1 0 0 1.566h4.162v4.162a.78.78 0 0 0 .783.782.784.784 0 0 0 .783-.782v-4.162h4.162a.783.783 0 1 0 0-1.566h-4.162v-4.162a.782.782 0 1 0-1.566 0v4.162h-4.162z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.543 124.904a4.127 4.127 0 0 1-3.51 2.005l-15.168 4.856-.693-4.022 9.184-4.984-8.898-6.408 6.519-7.629 11.841 11.036a4.134 4.134 0 0 1 .725 5.146z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.545 152.413H116.8c-3.362-23.048-6.785-46.16 3.329-54.787l11.929 1.942-1.526 10.125-6.658 7.629-3.329 35.091z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.328 103.744c-5.048 3.44-11.57 2.631-14.292-2.495 3.911-6.587 4.735-11.322 1.586-13.483a7.47 7.47 0 0 1 4.559-9.004l5.964 2.497c5.063 4.128 6.061 8.6 4.161 13.315l-1.978 9.17z",
    fill: "#00A39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.263 159.158H64.737v.412h166.526v-.412z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3 149.772a4.727 4.727 0 0 0 4.565-.804c1.599-1.342 2.1-3.553 2.508-5.599l1.206-6.055-2.525 1.738c-1.816 1.251-3.673 2.542-4.93 4.353-1.258 1.811-1.807 4.284-.797 6.244",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.691 157.523c-.319-2.316-.645-4.661-.422-7.002.198-2.08.833-4.11 2.124-5.775a9.617 9.617 0 0 1 2.464-2.233c.247-.155.474.235.228.39a9.137 9.137 0 0 0-3.612 4.358c-.786 2-.912 4.181-.777 6.306.082 1.284.256 2.561.43 3.836a.235.235 0 0 1-.157.278.23.23 0 0 1-.278-.158z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.433 154.064a3.518 3.518 0 0 0 3.231 1.2c1.53-.259 2.683-1.489 3.715-2.649l3.051-3.43-2.274.166c-1.635.119-3.312.248-4.8.938-1.488.689-2.77 2.068-2.86 3.706",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.815 158.847c.536-1.291 1.077-2.599 1.9-3.739a6.582 6.582 0 0 1 2.84-2.336 5.751 5.751 0 0 1 1.947-.407c.174-.005.173.265 0 .27a5.466 5.466 0 0 0-3.181 1.156c-1.01.794-1.735 1.88-2.308 3.017-.346.688-.642 1.399-.938 2.109a.14.14 0 0 1-.164.095.135.135 0 0 1-.096-.165z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.979 153.807a3.478 3.478 0 0 0 3.032 1.564c1.534-.072 2.814-1.144 3.966-2.161l3.406-3.008-2.254-.108c-1.622-.077-3.285-.15-4.829.35-1.545.5-2.969 1.704-3.251 3.302",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.792 158.854c1.53-2.708 3.306-5.717 6.477-6.679a7.236 7.236 0 0 1 2.725-.281c.289.025.217.471-.072.446a6.713 6.713 0 0 0-4.348 1.15c-1.225.834-2.18 1.994-2.988 3.225-.494.753-.938 1.539-1.381 2.323-.142.251-.556.07-.413-.184z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.274 154.634a3.65 3.65 0 0 1-3.522-.62c-1.234-1.036-1.621-2.742-1.935-4.322l-.931-4.672 1.949 1.342c1.402.965 2.835 1.961 3.805 3.359.971 1.398 1.394 3.306.615 4.819",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.736 159.069c.172-1.249.348-2.514.228-3.776a5.952 5.952 0 0 0-1.145-3.113 5.188 5.188 0 0 0-1.329-1.204c-.133-.084-.256.126-.124.21a4.922 4.922 0 0 1 1.948 2.35c.424 1.079.492 2.254.419 3.4a28.674 28.674 0 0 1-.232 2.068.126.126 0 0 0 .085.15.123.123 0 0 0 .15-.085z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.692 107.809a2.212 2.212 0 0 0 1.532-3.025l8.152-18.417-4.663-1.175-6.547 18.473a2.224 2.224 0 0 0 1.526 4.144z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.273 89.66-4.536-2.123a1 1 0 0 1-.534-.63.985.985 0 0 1 .128-.815l2.756-4.163a2.752 2.752 0 0 1 3.661-1.307 2.754 2.754 0 0 1 1.32 3.657l-1.425 4.768a.994.994 0 0 1-1.37.613z",
    fill: "#00A39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.333 77.406h-11.939a.928.928 0 0 1-.926-.926v-5.146a6.896 6.896 0 1 1 13.791 0v5.146a.928.928 0 0 1-.926.926z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.065 77.328a5.056 5.056 0 1 0 0-10.112 5.056 5.056 0 0 0 0 10.112z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89 71.849h-7.3l-.075-1.049-.374 1.049h-1.124l-.148-2.078-.742 2.078h-2.175v-.103a5.456 5.456 0 0 1 5.454-5.455h1.03a5.46 5.46 0 0 1 5.454 5.455v.103z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e2pz0wc16a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(64.737 32.43)",
    d: "M0 0h166.526v127.14H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9a91218362b65818de5c2f0f043ccb44.svg";
export { ForwardRef as ReactComponent };